import { MacroAutocomplete } from "@core/controls/document-template-editor/document-template-macros-autocompleter";
import { IMacro, ICompanyMacroOpenContext } from "../macro";

export const companyMacroAutocomplete: MacroAutocomplete[] = [
    {
        type: "autocompleteitem",
        text: "Компания",
        value: "компания",
        nested: [
            { type: "autocompleteitem", text: "Название", value: "название" },
            { type: "autocompleteitem", text: "Описание", value: "описание" },
            { type: "autocompleteitem", text: "Почта", value: "почта" },
            { type: "autocompleteitem", text: "Телефон", value: "телефон" },
            // { type: "autocompleteitem", text: "Улица", value: "улица" },
            // { type: "autocompleteitem", text: "Город", value: "город" },
            // { type: "autocompleteitem", text: "Регион", value: "регион" },
            // { type: "autocompleteitem", text: "Страна", value: "страна" },
            // { type: "autocompleteitem", text: "Почтовый индекс", value: "индекс" },
            { type: "autocompleteitem", text: "Адрес", value: "адрес" },
            { type: "autocompleteitem", text: "Сайт", value: "сайт" },
        ],
    },
];

export const CompanyMacroList: IMacro<ICompanyMacroOpenContext>[] = [
    {
        alias: ["компания.название", "company.name"],
        open: (context, args) => context.company.info.name,
    },
    {
        alias: ["компания.описание", "company.description"],
        open: (context, args) => context.company.info.description,
    },
    {
        alias: ["компания.почта", "company.email"],
        open: (context, args) => context.company.info.contacts?.email ?? "",
    },
    {
        alias: ["компания.телефон", "company.phone"],
        open: (context, args) => context.company.info.contacts?.phone ?? "",
    },
    {
        alias: ["компания.улица", "company.street"],
        open: (context, args) => context.company.info.contacts?.street ?? "",
    },
    {
        alias: ["компания.город", "company.city"],
        open: (context, args) => context.company.info.contacts?.city ?? "",
    },
    {
        alias: ["компания.регион", "company.region"],
        open: (context, args) => context.company.info.contacts?.region ?? "",
    },
    {
        alias: ["компания.страна", "company.country"],
        open: (context, args) => context.company.info.contacts?.country ?? "",
    },
    {
        alias: ["компания.индекс", "company.zip"],
        open: (context, args) => context.company.info.contacts?.zip ?? "",
    },
    {
        alias: ["компания.адрес", "company.address"],
        open: (context, args) => context.company.info.contacts?.address ?? "",
    },
    {
        alias: ["компания.сайт", "company.website"],
        open: (context, args) => context.company.info.contacts?.website ?? "",
    },
];
